var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("wf-online-api-keys")))]),
      !_vm.hasModlue
        ? _c("app-missing-module", { attrs: { "module-id": _vm.moduleId } })
        : [
            _vm.keys.length == 0
              ? _c(
                  "w-card-content",
                  [
                    _c(
                      "w-row",
                      [
                        _c("w-col", { attrs: { xs: "12" } }, [
                          _vm._v(" " + _vm._s(_vm.$ct("no-api-keys")) + " "),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "w-scroll-view",
              { attrs: { tag: "w-list" } },
              _vm._l(_vm.keys, function (key) {
                return _c(
                  "w-list-item",
                  { key: key.ID },
                  [
                    _c("w-list-item-text", [_vm._v(_vm._s(key.Name))]),
                    _c(
                      "w-list-item-action",
                      [
                        _c(
                          "w-button",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: _vm.$ct("remove-api-key"),
                                expression: "$ct('remove-api-key')",
                              },
                            ],
                            staticClass: "danger",
                            on: {
                              click: function ($event) {
                                return _vm.deleteKey(key)
                              },
                            },
                          },
                          [_c("w-fa", { attrs: { icon: "trash" } })],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
              1
            ),
            _c(
              "w-card-actions",
              [
                _c("w-spacer"),
                _c(
                  "w-button",
                  {
                    attrs: { icon: "plus" },
                    on: {
                      click: function ($event) {
                        return _vm.openNewModal()
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.$ct("common.add")) + " ")]
                ),
              ],
              1
            ),
            _c(
              "w-modal",
              {
                attrs: { "escape-close": "" },
                model: {
                  value: _vm.newApiKeyModal,
                  callback: function ($$v) {
                    _vm.newApiKeyModal = $$v
                  },
                  expression: "newApiKeyModal",
                },
              },
              [
                _c(
                  "w-card",
                  { attrs: { "max-width": "700" } },
                  [
                    _c("w-card-title", [
                      _vm._v(_vm._s(_vm.$ct("new-api-key"))),
                    ]),
                    _c(
                      "w-card-content",
                      [
                        _c(
                          "w-row",
                          [
                            _c(
                              "w-col",
                              { attrs: { xs: "12" } },
                              [
                                _c("w-input", {
                                  attrs: { label: _vm.$ct("api-key-name") },
                                  model: {
                                    value: _vm.newApiKeyName,
                                    callback: function ($$v) {
                                      _vm.newApiKeyName = $$v
                                    },
                                    expression: "newApiKeyName",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "w-card-actions",
                      [
                        _c(
                          "w-button",
                          {
                            staticClass: "cancel",
                            attrs: { icon: "times" },
                            on: {
                              click: function ($event) {
                                return _vm.cancelCreate()
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(_vm.$ct("common.cancel")) + " ")]
                        ),
                        _c("w-spacer"),
                        _c(
                          "w-button",
                          {
                            attrs: { icon: "save" },
                            on: {
                              click: function ($event) {
                                return _vm.createApiKey()
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(_vm.$ct("common.create")) + " ")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "w-modal",
              { attrs: { value: _vm.savedApiToken != "" } },
              [
                _c(
                  "w-card",
                  { attrs: { "max-width": "700" } },
                  [
                    _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("api-key")))]),
                    _c(
                      "w-card-content",
                      [
                        _c(
                          "w-row",
                          [
                            _c("w-col", { attrs: { xs: "12" } }, [
                              _vm._v(
                                " " + _vm._s(_vm.$ct("api-key-saved")) + " "
                              ),
                            ]),
                          ],
                          1
                        ),
                        _c("w-row", [
                          _c(
                            "div",
                            { style: { flexGrow: 1 } },
                            [
                              _c("w-input", {
                                ref: "savedKeyInput",
                                attrs: { value: _vm.savedApiToken },
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.copyLink()
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "copy-button",
                              style: { flexShrink: 0, flexGrow: 0 },
                            },
                            [
                              _c(
                                "w-button",
                                {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value: _vm.$ct("common.copy"),
                                      expression: "$ct('common.copy')",
                                    },
                                  ],
                                  staticClass: "flat",
                                  on: {
                                    click: function ($event) {
                                      return _vm.copyLink()
                                    },
                                  },
                                },
                                [_c("w-fa", { attrs: { icon: "copy" } })],
                                1
                              ),
                            ],
                            1
                          ),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "w-card-actions",
                      [
                        _c("w-spacer"),
                        _c(
                          "w-button",
                          {
                            attrs: { icon: "times" },
                            on: {
                              click: function ($event) {
                                _vm.savedApiToken = ""
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(_vm.$ct("common.close")) + " ")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }